import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", null, "Other", -1);
import { computed, ref, watch } from 'vue';
import removeEmojis from '@utils/remove-emojis';
import { Field } from 'vee-validate';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseCheckboxOtherInput',
    props: {
        value: { default: '' },
        validCheck: { type: Boolean, default: true },
        placeholder: { default: '' }
    },
    emits: ["input", "change"],
    setup(__props, { emit }) {
        const props = __props;
        const isInputFocused = ref(false);
        const otherInput = ref(null);
        const isChecked = computed(() => Boolean(props.value) || isInputFocused.value);
        watch(isInputFocused, (focused) => {
            if (!focused)
                emit('change', props.value);
        });
        function onCheckboxInput() {
            if (props.value) {
                emit('input', '');
                emit('change', '');
                return;
            }
            otherInput.value?.focus();
        }
        function onInput(value) {
            emit('input', typeof value === 'string' ? value : '');
        }
        return (_ctx, _cache) => {
            const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
            const _component_b_form_textarea = _resolveComponent("b-form-textarea");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_b_form_checkbox, {
                    size: "lg",
                    checked: isChecked.value,
                    class: "mr-2 mt-1 d-inline",
                    onChange: onCheckboxInput
                }, {
                    default: _withCtx(() => [
                        _hoisted_1
                    ], undefined, true),
                    _: 1
                }, 8, ["checked"]),
                _createVNode(_unref(Field), {
                    "model-value": _ctx.value,
                    name: "otherInput",
                    rules: { blank_text: isChecked.value }
                }, {
                    default: _withCtx(({ field }) => [
                        _createVNode(_component_b_form_textarea, _mergeProps(field, {
                            ref_key: "otherInput",
                            ref: otherInput,
                            size: "sm",
                            class: ["d-inline otherInput", { 'is-invalid': isChecked.value && !_ctx.validCheck }],
                            rows: "2",
                            formatter: _unref(removeEmojis),
                            placeholder: _ctx.placeholder,
                            onFocus: _cache[0] || (_cache[0] = ($event) => (isInputFocused.value = true)),
                            onBlur: _cache[1] || (_cache[1] = ($event) => (isInputFocused.value = false)),
                            onInput: onInput
                        }), null, 16, ["class", "formatter", "placeholder"])
                    ]),
                    _: 1
                }, 8, ["model-value", "rules"])
            ]));
        };
    }
});
